import { FC } from "react";
import { usePlayer } from "../hooks/usePlayer";
import { TextSkeleton } from "./TextSkeleton";

interface PlayerNameProps {
  playerId: string;
  variant?: "lastname, firstname" | "firstname lastname" | "lastname";
}

export const PlayerName: FC<PlayerNameProps> = (props) => {
  const { playerId, variant = "lastname" } = props;
  const player = usePlayer(playerId);

  if (!player.isSuccess || !player.data) {
    return <TextSkeleton>{variant}</TextSkeleton>;
  }

  switch (variant) {
    case "firstname lastname": {
      return (
        <>
          {player.data.firstName} {player.data.lastName}
        </>
      );
    }
    case "lastname, firstname": {
      return (
        <>
          {player.data.lastName}, {player.data.firstName}
        </>
      );
    }
    case "lastname": {
      return <>{player.data.lastName}</>;
    }
  }
};
